import { useEffect } from "react";

import { useLEZs } from "src/hooks";
import { getEmissionWMSOverLayer } from "src/utils/emission.utils";
import { EmissionType } from "src/types";
import { addOrUpdateActiveOverlayerAtom } from "src/atoms/overlayers";
import { useAtom } from "jotai";

interface Props {
  scenarioId: string | number;
}

export function LEZRoadsOnMap(props: Props) {
  const { data: lezsData } = useLEZs(props.scenarioId);
  const [, addOrUpdateActiveOverlayer] = useAtom(addOrUpdateActiveOverlayerAtom);

  /**
   * Effects
   */
  useEffect(showRoadsOnMap, [addOrUpdateActiveOverlayer, lezsData]);

  /**
   * Functions
   */
  function showRoadsOnMap() {
    if (!lezsData) return;

    const { geoserverFilter } = lezsData;
    const emissionLayer = getEmissionWMSOverLayer(EmissionType.TRAFFIC, geoserverFilter);

    addOrUpdateActiveOverlayer(emissionLayer);

    return function cleanup() {
      // keep the layer in activeLayers list, this keeps zIndex, opacity, ...
      addOrUpdateActiveOverlayer({
        ...emissionLayer,
        isActive: false,
      });
    };
  }

  return render();

  function render() {
    return null;
  }
}
